import type React from 'react';

import { IonButton } from '@ionic/react';

import './TSButton.scss';

export type ButtonVariant =
  | 'icon' // (2) LEPS refresh button, settings button
  | 'icon-big' // (2) Thumbs up and thumbs down
  | 'white' // (~30) Done (lived experience edit, community not found), Learn more (FA), session logs, FA onboarding next/accept
  | 'black' // (~19) Later (learn more FA)

  // Pseudo-buttons
  | 'clear-black' // (~2) onboarding header, clear preferences
  | 'clear-white' // (~2) other page headers,  FA onboarding skip
  | 'underline-black' // (~12) Edit lived experience, cancel editing lived experience, cancel, FA onboarding skip, link (about page / privacy policy) **no shadow

  // Chat
  | 'red' // (2) End chat buttons
  // LEPS
  | 'leps-brown' // (3) chat (LEPS peer card), Sort (LEPS), Helpline (LEPS)
  // Services
  | 'sp-blue' // (1) chat (service provider card)

  // FirstAlerts
  | 'grey7'; // (1) FA unsubscribed communities

type IonButtonProps = React.ComponentProps<typeof IonButton>;

interface TSButtonProps extends IonButtonProps {
  variant: ButtonVariant;
  disabled?: boolean;
}

export const TSButton: React.FC<TSButtonProps> = ({
  variant = 'white',
  disabled = false,
  size = 'small',
  children,
  className = '',
  ...props
}) => {
  const variantsWithoutShadow: ButtonVariant[] = ['icon', 'icon-big', 'clear-black', 'clear-white', 'underline-black'];
  const shadow = !variantsWithoutShadow.includes(variant);
  const combinedClassNames = `ion-no-margin title-medium ts-button ts-${variant} ${shadow ? 'ts-shadow' : ''} ${className} ${disabled ? 'disabled' : ''} `;

  return (
    <IonButton mode="ios" disabled={disabled} size={size} className={combinedClassNames} {...props}>
      {children}
    </IonButton>
  );
};
